/**
 * @module actions/customers
 */
import axios from 'axios'
import {
  API_URL,
  SET_CUSTOMERS
} from '../constants'

/**
 * @description Getting employees from API and dispatching event
 * @return {Promise} Axios promise
 */
export function getShops (id) {
  id = (typeof id !== 'undefined') ? id : 0
  let url = API_URL + '/Shop/' + id
  return dispatch => {
    return axios.get(url).then((res) => {
      dispatch({
        type: SET_CUSTOMERS,
        shops: res.data
      })
      return res
    })
  }
}
/**
 * @description Getting premium shops for Partners from API and dispatching event
 * @return {Promise} Axios promise
 */
export function getPremiumShops (id, department) {
  id = (typeof id !== 'undefined') ? id : 0
  let url = API_URL + '/PremiumShop/' + id
  if (department !== undefined && department !== null) {
    url += '?department=' + department
  }
  return dispatch => {
    return axios.get(url).then((res) => {
      dispatch({
        type: SET_CUSTOMERS,
        shops: res.data
      })
      return res
    })
  }
}
/**
 * @description Getting paint shops for Partners from API and dispatching event
 * @return {Promise} Axios promise
 */
export function getPaintShops (id) {
  id = (typeof id !== 'undefined') ? id : 0
  let url = API_URL + '/PaintShop/' + id
  return dispatch => {
    return axios.get(url).then((res) => {
      dispatch({
        type: SET_CUSTOMERS,
        shops: res.data
      })
      return res
    })
  }
}
/**
 * @description Getting employees from API and dispatching event
 * @return {Promise} Axios promise
 */
export function getShopsWithCustomers (id) {
  id = (typeof id !== 'undefined') ? id : 0
  let url = API_URL + '/Shop/' + id + '?active=1'
  return dispatch => {
    return axios.get(url).then((res) => {
      dispatch({
        type: SET_CUSTOMERS,
        shops: res.data
      })
      return res
    })
  }
}
/**
 * @description Getting customer from API
 * @return {Promise} Axios promise
 */
export function getShop (id) {
  let url = API_URL + '/Shop/Get/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Getting shopowner and employees
 * @return {Promise} Axios promise
 */
export function getShopUsers (id) {
  let url = API_URL + '/Shop/GetShopUsers/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Creating/saving a customer
 * @return {Promise} Axios promise
 */
export function CreateSaveShop (data) {
  let url = API_URL + '/Shop/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}
/**
 * @description Validates CVR and PNumber if such already exists for specified Country
 * @return {Promise} Axios promise
 */
export function ValidateCVRAndPNumber (data) {
  let url = API_URL + '/Shop/ValidateCVRAndPNumber'
  return dispatch => {
    return axios.post(url, data)
  }
}
/**
 * @description Getting shop partners
 * @return {Promise} Axios promise
 */
export function GetPartners () {
  let url = API_URL + '/Shop/Partners'
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * Created by: Bjørn
 * Date: 2018-01-17
 * @description Getting shop partners
 * @return {Promise} Axios promise
 */
export function getPartnersForOrder (id) {
  let url = API_URL + '/Shop/PartnersForOrder/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Getting shop small dashboard
 * @return {Promise} Axios promise
 */
export function GetSmallDashboard () {
  let url = API_URL + '/Shop/Reports/SmallDashboard'
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Update EstimationAnswer
 * @return {Promise} Axios promise
 */
export function UpdateEstimationAnswer (data) {
  let url = API_URL + '/Shop/SetEstimationAnswer'
  return dispatch => {
    return axios.post(url, data)
  }
}
/**
 * @description Get all rental cars
 * @return {Promise} Axios promise
 */
export function GetCarRental (rentalCarId) {
  let url = API_URL + '/CarRental/Get/' + rentalCarId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Get all rental cars
 * @return {Promise} Axios promise
 */
export function GetSimpleCarRentals (id, orderId) {
  id = (typeof id !== 'undefined') ? id : 0
  orderId = (typeof orderId !== 'undefined') ? orderId : 0
  let url = API_URL + '/SimpleCarRentals/Get/' + id + '/' + orderId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Get all rental cars
 * @return {Promise} Axios promise
 */
export function UpdateCarRental (editedCarRental) {
  let url = API_URL + '/CarRentals/Post'
  return dispatch => {
    return axios.post(url, editedCarRental)
  }
}

/**
 * @description Get rental car numbers
 * @return {Promise} Axios promise
 */
export function GetOpenCarRentalNumbers () {
  let url = API_URL + '/CarRental/GetOpenCarRentalNumbers/'
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Get log for rental car by rentalCarId
 * @return {Promise} Axios promise
 */
export function GetCarRentalLog (rentalCarId) {
  rentalCarId = (typeof rentalCarId !== 'undefined') ? rentalCarId : 0
  let url = API_URL + '/CarRental/Log/' + rentalCarId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Get rental car temporary unavailable
 * @return {Promise} Axios promise
 */
export function GetTempInoperative (rentalCarId) {
  rentalCarId = (typeof rentalCarId !== 'undefined') ? rentalCarId : 0
  let url = API_URL + '/CarRental/TempInactive/Get/' + rentalCarId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Make rental car temporary unavailable
 * @return {Promise} Axios promise
 */
export function MakeTempInoperative (data) {
  let url = API_URL + '/CarRental/TempInactive/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/shops.js